import { Injectable } from '@angular/core';
import { SmApiService } from 'common/services/core-services/sm-api.service';
import { API_METHODS, API_URL } from 'common/constants/sm-constants';
import { SystemService } from 'common/services/core-services/system.service';
import { FormDataService } from "../../base-data-services/form-data.service";
import { editInfo } from 'common/models/utility-models/utility-interface';
import { environment } from 'src/environments/environment';
import { TypesModel } from 'common/models/page-models/types/types-data-model';


@Injectable({
    providedIn: 'root'
})
export class ViewTypesDataService extends FormDataService<TypesModel> {
    
    constructor(http: SmApiService, protected override ss: SystemService) {
        super(API_URL.viewTypes, http, ss);
    }
    getEditUrlAndMethod(id: any): editInfo {
        const edit = {
            url: environment.apiUrl + API_URL.viewTypes,
            method: API_METHODS.post,
        }
        return edit;
    }

    override getUpdatePayload(data) {
        let payload;
        payload = {
            typeId: data.id,
           
        }
        return payload;
    }

    createInstance(): TypesModel {
        return new TypesModel();
    }

    override getDeleteUrl() {
        return '';
    }

    override transformDataModel(data: any[]) {
        return data;
    }


   
}
